import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

import './CoursesPaymentConfirmation.scss';
import { getString } from '../../helpers/styles';
import icons from '../../shared/assets/icons/redesign';
import { trackAction, usePlatform } from '../../helpers/tracking';

const { Check, Logo, CheckLock } = icons;

export default function CoursesPaymentConfirmation({
  user,
  hasAccess,
  course,
  startPolling,
  stopPolling
}) {
  const router = useRouter();
  const platform = usePlatform();

  const [userHasCourseAccess, setUserHasCourseAccess] = useState(false);

  const hasCourseAccess = course ? hasAccess : user.hasCourseAccess;

  useEffect(() => {
    if (!hasCourseAccess) startPolling(2000);
  }, []);

  useEffect(() => {
    if (hasCourseAccess) {
      stopPolling();
      setUserHasCourseAccess(true);
    }
  }, [hasCourseAccess]);

  return (
    <div className="coursesPaymentConfirmation">
      <div className="coursesPaymentConfirmation-header">
        <Logo />

        <span
          className="coursesPaymentConfirmation-close-icon"
          onClick={() => {
            router.back();

            trackAction(platform, 'coursesbetalengelukt', 'clickclosebutton');
          }}
        >
          &times;
        </span>
      </div>

      <div className="coursesPaymentConfirmation-check-icon-wrap">
        {userHasCourseAccess ? (
          <Check className="coursesPaymentConfirmation-check-icon" />
        ) : (
          <CheckLock />
        )}
      </div>

      <h3 className="coursesPaymentConfirmation-title">
        {userHasCourseAccess
          ? 'Je hebt nu toegang tot onze cursussen. Veel plezier.'
          : 'Je betaling is onderweg...'}
      </h3>

      <p className="coursesPaymentConfirmation-text">
        {!userHasCourseAccess &&
          <>
            Klik dit scherm niet weg.
          </>
        }
      </p>

      <button
        className={getString([
          {
            value: 'coursesPaymentConfirmation-button',
            condition: true
          },
          {
            value: 'coursesPaymentConfirmation-button-disabled',
            condition: !userHasCourseAccess
          }
        ])}
        onClick={() => {
          if (!userHasCourseAccess) return;

          router.push(
            course
              ? `/zwangerschapscursus/ouder-en-kind/${course.name}`
              : '/zwangerschapscursus/overzicht'
          );

          trackAction(platform, 'coursesbetalengelukt', 'clicknextbutton');
        }}
      >
        Volgende
      </button>
    </div>
  );
}
